import accounting from 'accounting';
import defaults from './options';
import { event } from './utils';

const argOptions = ['num', 'money'];

function bind(el, binding) {
    // console.log('zzz', el, binding);
    let bindarg = binding.arg;
    if(argOptions.indexOf(bindarg) == -1) {
        bindarg = argOptions[0];
    }
    let opt = defaults;
    if(bindarg === 'num') {
        opt = Object.assign({}, opt, { precision: 0, maxlength: 10 });
    }
    opt = Object.assign({}, opt, binding.value);

    // v-format used on a component that's not a input
    if(el.tagName.toLocaleUpperCase() !== 'INPUT') {
        var els = el.getElementsByTagName('input');
        if(els.length > 0) {
            el = els[0];
        }else {
            throw new Error("v-format requires 1 input, found " + els.length);
        }
    }

    el.oninput = function(e) {
        // console.log('oninput', e, el.value);
        if(!e.isTrusted) return;

        if(this.value && /^\d+\.?\d?/.test(this.value)) {
            // 限制输入长度
            var [integer, decimal] = (this.value + '').split(opt.decimal);
            if(integer) {
                integer = (integer + '').substr(0, opt.maxlength);
            }
            if(decimal) {
                decimal = (decimal + '').substr(0, opt.precision);
            }

            if(integer && decimal) {
                this.value = integer + opt.decimal + decimal;
            }else if(integer && decimal == '') {
                this.value = integer + opt.decimal;
            }else {
                this.value = integer;
            }
        }else {
            this.value = null;
        }
        // console.log('xxxx', this.value);
        this.dispatchEvent(event('input')); // 刷新model
        this.dispatchEvent(event('change')); // v-model.lazy
    };

    el.onkeypress = function(e) {
        // console.log('yyyy');
        // 限制输入
        e = e || window.event;
        const charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;

        // 判断小数点
        if(charcode == 46) {
            // 没有小数部分
            if(opt.precision <= 0) {
                e.preventDefault();
            }else if(this.value && this.value.includes('.')) {
                e.preventDefault();
            }
            return;
        }

        // 判断其他输入
        if(!/(\d|\.)/.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
            if(e.preventDefault) {
                e.preventDefault();
            }else {
                e.returnValue = false;
            }
        }
    };

    el.onblur = function(e) {
        // console.log('ccc', el.value, opt);
        // 修改格式
        if(this.value) {
            let method = accounting.format;
            const zero = binding.modifiers.zero;
            switch (bindarg) {
                case 'money':
                    method = accounting.formatMoney;
                    break;
                default:
                    break;
            }
            const num = Number(this.value);
            if(!zero && (num == 0 || isNaN(num))) {
                this.value = null;
            }else {
                this.value = method(el.value, {
                    symbol: opt.symbol,
                    format: opt.format,
                    precision: opt.precision,
                    decimal: opt.decimal,
                    thousand: opt.thousands
                });
            }
            this.dispatchEvent(event('input'));
        }
        this.dispatchEvent(event('compositionend'));
    };

    // force format after initialization
    setTimeout(() => {
        el.onblur();
        // el.dispatchEvent(event('blur')); // 初始化时会触发表单效验
    }, 0);
}

export default {
    name: 'format',
    bind: bind,
    unbind: function(el) {
        // console.log('v-format unbind!');
        el.oninput = null;
        el.onkeypress = null;
        el.onblur = null;
    }
};
